import { defaultConfig } from '@chakra-ui/react';

import { semanticColors } from './colors';
import { semanticShadows } from './shadows';

const semanticTokens = {
    ...defaultConfig.theme?.semanticTokens,
    shadows: semanticShadows,
    colors: semanticColors,
};

export { semanticTokens };
